export default [
  {
    path: "/raporsatiskalangun",
    name: "rapor-satis-kalan-gun-list",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raporsatiskalangun.Baslik",
      yetki: { k: [2001502] },
    },
  },
]
